"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserAccountAuthorizationsRoutes = void 0;
const route_1 = require("../route");
class UserAccountAuthorizationsRoutes extends route_1.Route {
    constructor() {
        super('user_account_authorizations');
    }
    getAuthorizationById(authorizationId) {
        return this.get(`/${authorizationId}`);
    }
    approveAuthorization(authorizationId) {
        return this.post(`/${authorizationId}/approve`);
    }
    denyAuthorization(authorizationId) {
        return this.post(`/${authorizationId}/deny`);
    }
    revokeAuthorization(authorizationId) {
        return this.post(`/${authorizationId}/revoke`);
    }
    getAuthorizations() {
        return this.get('/');
    }
    getAuthorizationsBy({ status }) {
        return this.get('/', { status });
    }
}
exports.UserAccountAuthorizationsRoutes = UserAccountAuthorizationsRoutes;
//# sourceMappingURL=user_account_authorizations.js.map